import React from "react";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTrySelect,
} from "common/method/handleNotificationAlert";
import { clubmember_send_kyc_otp } from "redux/profile/club_send-kyc_otp";
import { BoxStyled } from "styledComponents/component";

const StepOne = ({
  setIndexChild,
  national_id,
  setLoading,
  title,
  loading,
}) => {
  const handelSubmit = () => {
    let _data = {
      national_id: "0022893938",
      flag_info: "set_password",
    };
    setLoading(true);

    clubmember_send_kyc_otp(_data)
      .then((res) => {
        handleNotificationAlertTrySelect(res);

        if (res.data.response?.data?.sms_result?.is_successful)
          setIndexChild(1);
      })
      .catch(() => {
        handleNotificationAlertCatch();
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return (
    <>
      <BoxStyled minHeight={150}>
        <div>
          <h1 className="pr-3 mb-3 mt-2 text-[#646464] text-lg">{title}</h1>
        </div>
        <h1 className="pr-3 mb-3 mt-2 text-[#646464] text-base">
          کاربر گرامی توجه فرمایید برای تغییر رمز عبور بر روی دکمه ارسال رمز
          کلیک کرده و پیامک رمز یکبار مصرف به شماره سجامی شما ارسال خواهد شد
        </h1>
        <button
          className="border border-primary py-2 px-10 rounded-lg text-primary relative justify-center items-center mr-2 mt-3 w-max"
          onClick={() => handelSubmit()}
          disabled={loading}
        >
          {/* <div className="ml-1 ">
                        <VscCopy />
                      </div> */}
          ارسال رمز یکبار مصرف
          {loading && (
            <svg
              className="animate-spin -ml-1 mr-3 h-5 w-5 text-primary absolute top-2 left-5 "
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                stroke-width="4"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              ></path>
            </svg>
          )}
        </button>
      </BoxStyled>
    </>
  );
};

export default StepOne;
